



































































































































import Vue from 'vue'
import _ from 'lodash'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn, DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import {
  FETCH_PRODUCT_FELD_LIST, FETCH_PRODUCT_GROUP,
  SEARCH_PRODUCT_LIST
} from '@/store/action-types'
import ProductWindow from '@/components/master-data/product/ProductWindow.vue'
import {
  ProductGroupResponse, ProductSearchRecordResponse,
  ProductZusatzfelderType,
  ProductZusatzfelderTypesResponse
} from '@/types/service-response'
import { ProductSearchPayload, ProductZusatzfelderSearchItem } from '@/types/payload'
import { ProductGroup } from '@/model/products/ProductGroup'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { ProductSearchRecord } from '@/model/products/ProductSearchRecord'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'
import { KeyActionEnum } from '@/types/enums'

class SelectAll extends KeyAction {}

interface ComponentData {
  tableHeight: string,
  loading: boolean
  showDialog: boolean
  productIdList: number[]

  productGroupList: ProductGroup[]

  schluessel: string
  bezeichnung: string
  beschreibung: string
  gruppe: number[]
  barcode: string
  externeProduktNummer: string
  verfuegbar: boolean
  nurBevorzugteLager: boolean
  nurAuslierfortSyzSRO: boolean
  gesperrteAusblenden: boolean
  verfuegbarReservationen: boolean
  verfuegbarBestellungen: boolean

  productList: ProductSearchRecord[]
  isDetailButtonDisabled: boolean
  productStatus: string
  feldList: ProductZusatzfelderType[]
  operatorList: any[]
  boolOperatorNextList: any[]
  additionalFilterList: any[]

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ProductSearchPage',

  components: {
    ProductWindow,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    productGroupId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,
      showDialog: false,
      productIdList: [],

      productGroupList: [],

      schluessel: '',
      bezeichnung: '',
      beschreibung: '',
      gruppe: [],
      barcode: '',
      externeProduktNummer: '',
      verfuegbar: false,
      nurBevorzugteLager: false,
      nurAuslierfortSyzSRO: false,
      gesperrteAusblenden: false,
      verfuegbarReservationen: false,
      verfuegbarBestellungen: false,

      productList: [],
      isDetailButtonDisabled: true,
      productStatus: '1',
      feldList: [],
      operatorList: [
        {id: 1, name: '='},
        {id: 2, name: this.$t('productSearch.operator1').toString()},
        {id: 3, name: this.$t('productSearch.operator2').toString()},
        {id: 4, name: this.$t('productSearch.operator3').toString()},
        {id: 5, name: this.$t('productSearch.operator4').toString()},
        {id: 6, name: this.$t('productSearch.operator5').toString()},
        {id: 7, name: this.$t('productSearch.operator6').toString()},
        {id: 8, name: this.$t('productSearch.operator7').toString()}
      ],
      boolOperatorNextList: [
        {id: 0, name: ''},
        {id: 1, name: this.$t('productSearch.boolOperator1').toString()},
        {id: 2, name: this.$t('productSearch.boolOperator2').toString()}
      ],
      additionalFilterList: [
        {id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}
      ],

      keyActions: []
    }
  },

  watch: {
    $route (newVal: any): void {
      if (newVal.query.create) {
        this.productIdList = [0]
        this.showDialog = true
      }

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    productGroupId (newVal: number): void {
      if(newVal) {
        if(!this.gruppe.includes(newVal)) {
          this.gruppe.push(newVal)
        }
      }
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: SelectAll | null): boolean {
      if(action instanceof SelectAll) {
        return !this.showDialog
      } else {
        return false
      }
    },

    selectAll (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      //@ts-ignore
      this.$refs.dataGrid.instance.selectAll()
    },

    onChangeFeld (index: number, item: any): void {
      if(item === 0) {
        this.additionalFilterList[index].feld = null
        this.additionalFilterList[index].operator = null
        this.additionalFilterList[index].inhalt = ''
        this.additionalFilterList[index].boolOperatorNext = 0
        this.additionalFilterList.splice(index + 1, this.additionalFilterList.length)
      }
    },

    onChangeAdditional (index: number, item: any): void {
      if(item === 0) {
        if(this.additionalFilterList && this.additionalFilterList[index + 1]) {
          this.additionalFilterList.splice(index + 1, 1)
        }
      } else {
        if(this.additionalFilterList && !this.additionalFilterList[index + 1]) {
          const highId = _.maxBy(this.additionalFilterList, 'id')
          this.additionalFilterList.push({id: highId.id + 1, feld: null, operator: null, inhalt: '', boolOperatorNext: 0})
        }
      }
    },

    startCreate (): void {
      this.productIdList = [0]
    },

    productCreated (product: ProductSearchRecord): void {
      this.productIdList = [product.id]
      this.productList.push(product)
    },

    productEdited (): void {
      this.searchProduct()
    },

    productDeleted (id: number) : void {
      this.productIdList.splice(this.productIdList.indexOf(id), 1)
      if(this.productIdList.length === 0) {
        this.showDialog = false
        this.searchProduct()
      } else {
        this.searchProduct()
      }
    },

    onCloseDialog (): void {
      this.showDialog = false
      this.productIdList = []
      if(this.productGroupId) {
        this.$router.push({ path: `/product/${this.productGroupId}`})
      } else {
        this.$router.push({ path: '/product'})
      }
    },

    onSearchButtonClick (): void {
      this.productList = []

      let data: any = this.getRouteData()

      data.schluessel = this.schluessel
      data.bezeichnung = this.bezeichnung
      data.beschreibung = this.beschreibung
      data.gruppe = this.gruppe
      data.barcode = this.barcode
      data.externeProduktNummer = this.externeProduktNummer
      data.verfuegbar = this.verfuegbar
      data.nurBevorzugteLager = this.nurBevorzugteLager
      data.nurAuslierfortSyzSRO = this.nurAuslierfortSyzSRO
      data.gesperrteAusblenden = this.gesperrteAusblenden
      data.verfuegbarReservationen = this.verfuegbarReservationen
      data.verfuegbarBestellungen = this.verfuegbarBestellungen
      data.productStatus = this.productStatus
      data.productZusatzfelderSearchItems = this.additionalFilterList

      this.$router.push({name: 'ProductSearch', query: { data: JSON.stringify(data) }})

      this.searchProduct()
    },

    onSelectionChanged (data: any) {
      this.isDetailButtonDisabled = data.selectedRowKeys.length <= 0

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = data.selectedRowKeys
      this.$router.push({name: 'ProductSearch', query: { data: JSON.stringify(ruteData) }})
    },

    rowDblClick(event: any): void {
      this.productIdList.push(event.data.id)
      this.showDialog = true

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = [event.data.id]
      ruteData.showDialog = this.showDialog
      this.$router.push({name: 'ProductSearch', query: { data: JSON.stringify(ruteData) }})
    },

    onDetailClick (): void {
      //@ts-ignore
      const selectedProductIdList: number[] = this.$refs.dataGrid.instance.getSelectedRowKeys()

      if(selectedProductIdList.length > 0) {
        this.productIdList = selectedProductIdList
        this.showDialog = true

        let ruteData: any = this.getRouteData()
        ruteData.showDialog = this.showDialog
        this.$router.push({name: 'ProductSearch', query: { data: JSON.stringify(ruteData) }})
      }
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 105px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    async searchProduct (): Promise<void> {
      let additionalFilterSearchList: ProductZusatzfelderSearchItem[] = []
      this.additionalFilterList.forEach((item: any) => {
        if(item.feld && item.operator && item.inhalt) {
          additionalFilterSearchList.push({
            Feldtyp: item.feld,
            Operator: item.operator,
            BoolOperatorNext: item.boolOperatorNext,
            Inhalt: item.inhalt
          })
        }
      })

      const payload: ProductSearchPayload = {
        Bezeichnung: this.bezeichnung,
        Gruppe: null,
        ProduktGruppen: this.gruppe,
        ProductZusatzfelderSearchItems: additionalFilterSearchList,

        Mitarbeiter: this.currentUserId,
        Sprache: this.selectedLanguageId,
        //MaxRecords: number
        Alle: this.productStatus === '0',
        Aktiv: this.productStatus === '1',
        Passiv: this.productStatus === '2',
        Schluessel: this.schluessel,
        Beschreibung: this.beschreibung,
        Barcode: this.barcode,
        Nummer: this.externeProduktNummer
      }

      try {
        this.loading = true
        const response: ProductSearchRecordResponse = await this.$store.dispatch(SEARCH_PRODUCT_LIST, payload)
        if(!response.IsError && response.Results) {
          this.productList = ProductSearchRecord.createListFromResponse(response.Results)

          let data: any = this.getRouteData()
          if(this.$route.path === '/product' && data.selectedRowKeys) {
            let selectedRowKeyList: number[] = []
            this.productList.forEach((item: ProductSearchRecord) => {
              if(data.selectedRowKeys.includes(item.id)) {
                selectedRowKeyList.push(item.id)
              }
            })

            setTimeout(() => {
              //@ts-ignore
              this.$refs.dataGrid.instance.selectRows(selectedRowKeyList)
              this.showDialog = data.showDialog !== undefined && selectedRowKeyList.length > 0 ? data.showDialog : false
            }, 100)
          }
        }
      } catch {

      } finally {
        this.loading = false
      }
    },

    async fetchProductGroupList (): Promise<void> {
      try {
        const response: ProductGroupResponse = await this.$store.dispatch(FETCH_PRODUCT_GROUP)
        if(!response.IsError && response.Data) {
          this.productGroupList = ProductGroup.createFromResponse(response.Data)
        } else {}
      } catch {}
    },

    async fetchFeldList (): Promise<void> {
      try {
        const response: ProductZusatzfelderTypesResponse = await this.$store.dispatch(FETCH_PRODUCT_FELD_LIST)
        if(!response.IsError) {
          this.feldList = response.Data
          this.feldList.unshift({
            ID: 0,
            Bezeichnung: ''
          })
        }
      } catch {
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/product') {
        this.schluessel = data && data.schluessel ? data.schluessel : ''
        this.bezeichnung = data && data.bezeichnung ? data.bezeichnung : ''
        this.beschreibung = data && data.beschreibung ? data.beschreibung : ''
        this.gruppe = data && data.gruppe ? data.gruppe : []
        this.barcode = data && data.barcode ? data.barcode : ''
        this.externeProduktNummer = data && data.externeProduktNummer ? data.externeProduktNummer : ''
        this.verfuegbar = data && data.verfuegbar ? data.verfuegbar : false
        this.nurBevorzugteLager = data && data.nurBevorzugteLager ? data.nurBevorzugteLager : false
        this.nurAuslierfortSyzSRO = data && data.nurAuslierfortSyzSRO ? data.nurAuslierfortSyzSRO : false
        this.gesperrteAusblenden = data && data.gesperrteAusblenden ? data.gesperrteAusblenden : false
        this.verfuegbarReservationen = data && data.verfuegbarReservationen ? data.verfuegbarReservationen : false
        this.verfuegbarBestellungen = data && data.verfuegbarBestellungen ? data.verfuegbarBestellungen : false
        this.productStatus = data && data.productStatus ? data.productStatus : '1'
        this.additionalFilterList = data && data.productZusatzfelderSearchItems ? data.productZusatzfelderSearchItems : [{id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}]

        this.productIdList = data.selectedRowKeys ? data.selectedRowKeys : []

        if(!_.isEmpty(data)) {
          this.searchProduct()
        }
      }
    }

  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  beforeMount () {
    this.keyActions = [
      new SelectAll(KeyActionEnum.selectAll, this.selectAll, this.resolver,  null)
    ]
  },

  async mounted (): Promise<void> {
    window.addEventListener('keydown', this.onKeydown)

    this.setDataFromRoute()
    if(this.$route.query.create) {
      this.productIdList = [0]
      this.showDialog = true
    }

    if(this.productGroupId) {
      this.gruppe.push(this.productGroupId)
    }

    this.fetchProductGroupList()
    this.fetchFeldList()

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
